import React, { createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmBox from '../../components/confirmBox/ConfirmBox';
import Loader from './../../components/loader/Loader';
import useCustomSnackbar from "../../helper/useCustomSnackbar";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const [confirmVisible, setConfirmVisible] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const showSnakbar = useCustomSnackbar()

  const login = async (token) => {
    console.log("token authContext page", token)
    setToken(token);
    localStorage.setItem("token", token);
    navigate("/");
  };

  const handleLogout = () => {
    setLoading(true);
    setConfirmVisible(false);
    setToken(null);
    localStorage.clear();
    showSnakbar('success', "Logged out successfully")
    setTimeout(() => {
      navigate("/login");
      setLoading(false);
    }, 2000);
  };

  const cancelLogout = () => {
    setConfirmVisible(false);
  };

  const confirmLogout = () => {
    setConfirmVisible(true)
  };

  const isAuthenticated = () => !!token;
  console.log("isAuthenticated==>", isAuthenticated)

  return (
    <AuthContext.Provider
      value={{ token, login, confirmLogout, isAuthenticated }}
    >
      {children}
      <ConfirmBox
        visible={confirmVisible}
        onConfirm={handleLogout}
        onCancel={cancelLogout}

      />
      {loading && <Loader size='large' />}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
